/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Current Stock By Date
 * Description: CurrentData for Current Stock By Date
 */

import { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import CommonApiService from '../../../services/CommonApiService';
import { useCurrentStockByDate } from './ContextAPI';
import ConsolidatedDataTable from './ConsolidatedDataTable';
import DataTable from './DataTable';

export default function CurrentData() {
    const { drugCategory, getDrugCategory } = CommonApiService();
    const { data, setShowPdf, stockDate, consolidated } = useCurrentStockByDate();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const handlePrintPreview = () => {
        setShowPdf(true);
    };
    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <div className="dataTableHeaderNone padding-0">
                    {consolidated ? (
                        <ConsolidatedDataTable
                            data={data?.filter((el) => el.category_id == item.id)}
                        />
                    ) : (
                        <DataTable data={data?.filter((el) => el.category_id == item.id)} />
                    )}
                </div>
            </Tab>
        ));

    const exportAllTabsToMultiSheet = () => {
        const wb = XLSX.utils.book_new();
        drugCategory?.forEach((cat) => {
            const filtered =
                data?.filter((item) => parseFloat(item.category_id) === parseFloat(cat.id)) || [];
            const formatted = consolidated
                ? filtered.map((item) => ({
                      'Code No': item.code_no,
                      Item: item.drug_name.replace(/^\S+\s*/, ''),
                      'Stock Date': stockDate,
                      'Available Qty': item.available_qty,
                      'Location From': item.warehouse_name
                          ? item.warehouse_name
                          : item.facility_name
                          ? item.facility_name
                          : item?.partner_name
                          ? item.partner_name
                          : item?.dispensary_name,
                  }))
                : filtered.flatMap((item) =>
                      item.batch_info.map((batch) => ({
                          // Category: cat.name,
                          'Code No': item.code_no,
                          Item: item.drug_name.replace(/^\S+\s*/, ''),
                          'Batch No': batch.batch_no,
                          'Expired Date': batch.expire_date,
                          'Stock Date': stockDate,
                          'Available Qty': batch.available_qty,
                          'Unit Price': batch.unit_price,
                          'Total Value': batch.available_qty * batch.unit_price,
                          'Location From': item.warehouse_name ? item.warehouse_name : item.facility_name ? item.facility_name : item?.partner_name ? item.partner_name : item?.dispensary_name,
                      }))
                  );
            const ws = XLSX.utils.json_to_sheet(formatted);
            XLSX.utils.book_append_sheet(wb, ws, cat.name?.slice(0, 31)); // Excel sheet name limit
        });

        XLSX.writeFile(wb, 'CurrentStockByDate_MultiSheet.xlsx');
    };

    return (
        <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h6>
                    Current Stock By Date
                    {stockDate && (
                        <span className="ms-2 text-primary fw-bold">({stockDate})</span>
                    )}
                </h6>
                <div>
                    <Button className="btn btn-dark me-2" onClick={handlePrintPreview}>
                        Print Preview
                    </Button>
                    <Button className="btn btn-success" onClick={exportAllTabsToMultiSheet}>
                        Export Excel
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Col>
                </Row>

                <div className="formFooter">
                    <Button
                        className={`btnInfo me-2 ms-2 ${page === 0 && 'd-none'}`}
                        variant="secondary"
                        onClick={() => {
                            setPage((currPage) => currPage - 1);
                        }}
                    >
                        Prev
                    </Button>
                    <Button
                        type="button"
                        className="btnSuccess"
                        disabled={page == pageLength - 1}
                        variant="success"
                        style={{ minWidth: '6rem' }}
                        onClick={() => setPage((currPage) => currPage + 1)}
                    >
                        Next
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
}
